import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
export default class CheckBox extends React.Component {
  localizedData = [
    { text: "Yes", value: true },
    { text: "No", value: false },
  ];

  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.value,
    });
  };

  handleEditCell = () => {
    this.props.onEditCell(this.props.dataItem, this.props.field)
  }

  render() {
    const { dataItem, field } = this.props;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (field && dataItem.inEdit === field) {
      return (
        <DropDownList
          style={ { width: "100px" } }
          onChange={ this.handleChange }
          value={ this.localizedData.find((c) => c.value === dataValue) }
          data={ this.localizedData }
          textField="text"
        />
      )
    }
    if (dataItem.inEdit !== field) {
      return (
        secureLocalStorage.getItem("role") == "Standard User" || secureLocalStorage.getItem("role") == "View Only" ? 
        (
          <td >
          {dataValue.toString() == "true" ?
            "Yes"
            :
            "No"
          }
        </td>
        ):(
          <td onClick={ this.handleEditCell }>
          {dataValue.toString() == "true" ?
            "Yes"
            :
            "No"
          }
        </td>
        )
        
      )
    }
  
  }
}
